var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-full gap-2"},[_c('span',{staticClass:"label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"relative flex items-center justify-between"},[_vm._t("default"),_vm._v(" "),_c('ChevronIcon',{staticClass:"h-[7px] absolute right-4"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }